export const buttonEnum = {
    PLAY: 'AUDIO_PLAY',
    MENU: 'VR_MENU',
    MENU_TOGGLE: 'MENU_TOGGLE'
};

export const positionEnum = {
    PLAY_NON_VR: {
        left: 40,
        bottom: 40
    },

    PLAY_VR: {
        left: window.innerWidth / 2,
        height: window.innerHeight / 2
    },

    MENU_VR: {
        left: window.innerWidth / 2,
        height: window.innerHeight / 2,
        zAxisMenuPosition: -0.5,
        yAxisMenuPosition: -0.7
    },
    MENU_VR_LANDSCAPE: {
        yAxisMenuPosition: -0.2
    },

    MENU_TOGGLE: {
        left: window.innerWidth / 2.1,
        height: window.innerHeight / 2
    }
};

export const scaleEnum = {
        width :{
            744: .06185
        },
        height: {
            1422: .1237
        }
};

export const dimensionEnum = {
    PLAY_NON_VR: {
        width: 40,
        height: 40
    },

    PLAY_VR: {
        width: 6000,
        height: 6000
    },

    MENU_VR: {
        width: 7000,
        height: 7000
    },

    MENU_TOGGLE: {
        width: 7000,
        height: 7000
    }
};